import React , { useEffect, useState } from 'react'; 
import storage from '../factory/StorageFactory.js';
import '../Card/card-style.css';
import FormContainer from '../components/FormContainer.jsx';
import config from '../appconfig/config.json';

const InvalidEntity = (props) => {

    useEffect(() => {
        window.scrollTo(0,0);
 
        storage.clearAll();
     }, []);

     const handleOnClick = () =>{
        window.location.href = config.link.GetInTouch;
    }

    const handleCancelClick = ()=> {
        window.location.href = config.link.Cancle;
    }

    const displayErrMsg = () => {

        let errMsg = ''
        if(props.location.state !== undefined) {
            let errType = props.location.state.errType;
            if(errType === config.ErrType.NonLive) {
                errMsg = 'We could not find your business records in ACRA.\nDo register your business with ACRA and re-apply with us. <Code xxx>';
            }
            else if(errType === config.ErrType.EmptyCompDtls || errType === config.ErrType.EmptyAPDtls) {
                errMsg = "We are unable to proceed your application."
            }
            else if(errType === config.ErrType.ConsentFailed) {
                errMsg = 'Your application is currently on hold.\n We will get in touch with you within 2 days once we have received all the required information.';
            }
            else if(errType === config.ErrType.InvalidMyInfoBiz || errType === config.ErrType.InvalidMyInfoPerson) {
                errMsg = 'Missing data from MyInfo. Do update in MyInfo before reapplying.';
            }
            else if(errType === config.ErrType.InvalidMyInfoSubAP) {
                errMsg = 'Missing data from MyInfo. Do update in MyInfo before resuming your application via the email link.';
            }
            else if(errType === config.ErrType.InvalidCompType){
                errMsg = 'Your request is unsuccessful due to business type.';
            }
            else if(errType === config.ErrType.InvalidProdType) {
                errMsg = 'Your request is unsucessful due to invalid product type.';
            }
        }
     
        return errMsg;
    }

    return(
        <FormContainer>
            <div className="row around-xs elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <legend id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px'}}>{'Oops!'}</legend>
                </div>
            </div>
            <div style={{paddingTop: "10px"}}><hr className="yellowPanelLine" /></div>
            <br/>     
            <div className="row around-xs inputPair elementVisible">
            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <legend id={'lmsg1'} style={{textAlign:'center',paddingTop:'20px',whiteSpace:'pre-line'}}>{displayErrMsg()}</legend>
            </div>
             </div>
             <br/>
            
            <div className="row around-xs inputPair elementVisible">
                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{ paddingBottom: "20px" }}>
                    <button className="btn btn-back" onClick={handleCancelClick}>{'CANCEL'}</button>
                    <button type={'submit'} className="k-button btn btn-success btn-float-right" onClick={handleOnClick}>{'GET IN TOUCH'}</button>
                </div>
            </div>  
        </FormContainer>
    )
}

export default InvalidEntity;